import { useState } from "react";
import { useIsMobile } from "./Useismobile";

export default function Navbar({ theme, onToggleTheme }) {
  const { bg, fg, border, muted, darkMode } = theme;
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);

  const resumeHref = "/david_olarinde.pdf"; // file must be in /public

  return (
    <>
      <nav
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: isMobile ? "16px 20px" : "18px 40px",
          borderBottom: `1px solid ${border}`,
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: bg,
          backdropFilter: "blur(12px)",
        }}
      >
        <span
          style={{
            fontSize: isMobile ? 10 : 11,
            letterSpacing: "0.18em",
            fontWeight: 600,
            color: fg,
          }}
        >
          DAVID OLARINDE
        </span>

        {!isMobile && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 14px",
              border: `1px solid ${border}`,
              borderRadius: 100,
              fontSize: 10,
              letterSpacing: "0.12em",
              color: muted,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#84cc16",
                display: "inline-block",
              }}
            />
            OPEN TO WORK
          </div>
        )}

        {!isMobile ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button
              onClick={onToggleTheme}
              style={{
                padding: "7px 18px",
                fontSize: 10,
                letterSpacing: "0.14em",
                border: `1px solid ${border}`,
                borderRadius: 100,
                background: "transparent",
                color: muted,
                cursor: "pointer",
                fontFamily: "inherit",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = fg)}
              onMouseLeave={(e) => (e.currentTarget.style.color = muted)}
            >
              {darkMode ? "☀ LIGHT" : "☾ DARK"}
            </button>

            <a
              href={resumeHref}
              download
              style={{
                padding: "7px 18px",
                fontSize: 10,
                letterSpacing: "0.14em",
                border: `1px solid ${fg}`,
                borderRadius: 100,
                background: fg,
                color: bg,
                textDecoration: "none",
                display: "inline-block",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#84cc16";
                e.currentTarget.style.borderColor = "#84cc16";
                e.currentTarget.style.color = "#000";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = fg;
                e.currentTarget.style.borderColor = fg;
                e.currentTarget.style.color = bg;
              }}
            >
              RÉSUMÉ ↓
            </a>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button
              onClick={onToggleTheme}
              style={{
                background: "transparent",
                border: `1px solid ${border}`,
                borderRadius: 8,
                padding: "7px 10px",
                cursor: "pointer",
                color: muted,
                fontSize: 12,
                lineHeight: 1,
                fontFamily: "inherit",
              }}
            >
              {darkMode ? "☀" : "☾"}
            </button>

            <button
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                background: "transparent",
                border: `1px solid ${border}`,
                borderRadius: 8,
                padding: "7px 10px",
                cursor: "pointer",
                color: fg,
                fontSize: 14,
                lineHeight: 1,
              }}
              aria-label="Toggle menu"
            >
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>
        )}
      </nav>

      {isMobile && menuOpen && (
        <div
          style={{
            position: "fixed",
            top: 57,
            left: 0,
            right: 0,
            zIndex: 99,
            background: bg,
            borderBottom: `1px solid ${border}`,
            padding: "16px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 12,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 10,
              letterSpacing: "0.12em",
              color: muted,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#84cc16",
                display: "inline-block",
              }}
            />
            OPEN TO WORK
          </div>

          <div style={{ height: 1, background: border }} />

          <a
            href={resumeHref}
            download
            onClick={() => setMenuOpen(false)}
            style={{
              padding: "12px",
              fontSize: 11,
              letterSpacing: "0.14em",
              border: `1px solid ${fg}`,
              borderRadius: 10,
              background: fg,
              color: bg,
              textDecoration: "none",
              textAlign: "center",
              display: "block",
            }}
          >
            DOWNLOAD RÉSUMÉ ↓
          </a>
        </div>
      )}
    </>
  );
}